export default {"src":"/_next/static/media/pet-profile-imgae-uploader-icon.be74b563.svg","height":57,"width":56,"blurWidth":0,"blurHeight":0};